import React, { useMemo, useState } from "react";
import { Button, Popover } from "antd";
import axios from "axios";
import has from "lodash/has";
import Services from "../../Services/dataService";
import ProgressBar from "./ProgressBar";
import Config, { mapMarkerData, mapCensusTabelData } from "./Config";
import pick from "lodash/pick";
import { formateString } from "../Common/Functions";
import { Constant } from "../Common";

import userServices from "../../UserServices/UserServices";
const { variables } = Constant;
const { clientDataConfig, censusDataConfig } = Config;

function ShopDownloadStsts({
	selecteddropDown,
	currentSelectedTypeIndex,
	shopCounts,
	keyNameMapping,
	shopsStructure,
	apiTracking,
	dispatch,
	areasMapping,
	selectedType,
	currentPolygonsSelectedType,
	keyMapping,
	buttonLabel,
	title,
	extraFilters
}) {
	let [popOverOpsn, setPopOverOpen] = useState(false);
	const { tenant } = useMemo(() => pick(userServices.getCurrentUser(), ["tenant", "isSuperAdmin"]), []);

	const { functionToDataFetch, computeData } = useMemo(() => {
		if (["-Client"].includes(keyMapping)) {
			return {
				functionToDataFetch: Services.fetchClientShopsOfPolygon,
				computeData: computeClientShopsData
			};
		} else if ([`-${variables.bat_contracted_outlets}`].includes(keyMapping)) {
			return {
				functionToDataFetch: Services.fetchClientShopsOfPolygon,
				computeData: compute3rdDataShopsData
			};
		} else {
			return { functionToDataFetch: Services.fetchCensusShopsOfPolygon, computeData: computeCensusShopsData };
		}
	}, [keyMapping]);

	const disable = useMemo(() => {
		return currentPolygonsSelectedType !== selectedType;
	}, [currentPolygonsSelectedType, selectedType]);

	return (
		<div className="pr-3 flex-row py-2">
			{
				<Popover
					className="primaryclr"
					placement="rightBottom"
					content={
						<div style={{ "max-height": "75vh", "overflow-y": "auto" }} className="border-none shadow ">
							<table
								className="table table-striped table-borderedx table-hover border-none"
								style={{ width: "100%" }}
							>
								<tr>
									<th className="elipsis-count">Title</th>
									<th className="elipsis">Action/Status</th>
									<th className="elipsis">Available Shops</th>
									<th className="elipsis">Downloading</th>

									{/* <th className="elipsis">Shops Available</th> */}
								</tr>
								{selecteddropDown[currentSelectedTypeIndex]?.map(key => {
									const originalKey = key;
									key = `${key}${keyMapping}`;
									return (
										<tr>
											{((!has(shopCounts, key) ||
												(has(shopCounts, key) && shopCounts[key] === 0)) && (
												<>
													<td className="elipsis-count">{keyNameMapping[originalKey]}</td>
													<td className="elipsis">No Shop Available</td>
													<td className="elipsis">---</td>
													<td className="elipsis">---</td>
												</>
											)) || (
												<>
													<td className="elipsis-count">{keyNameMapping[originalKey]}</td>
													<td className="elipsis " style={{ height: "46px" }}>
														{(shopsStructure.get(key)?.length >= shopCounts[key] && (
															<>Complete</>
														)) ||
															apiTracking[key] || (
																<Button
																	className="shop-download-btn"
																	onClick={async () => {
																		const source = axios.CancelToken.source();

																		dispatch({
																			type: "setObject",
																			actions: {
																				set: {
																					[`apiTracking.${key}`]: (
																						<Button
																							className="shop-download-btn"
																							onClick={() => {
																								source.cancel(
																									"Operation canceled by the user."
																								);
																								dispatch({
																									type: "setObject",
																									actions: {
																										set: {
																											[`apiTracking.${key}`]:
																												null
																										}
																									}
																								});
																							}}
																						>
																							Cancel
																						</Button>
																					)
																				}
																			}
																		});

																		let totalShopsFetched =
																			shopsStructure?.get(key)?.length || 0;
																		let exclude = getAllSubAreas({
																			_id: key,
																			areasMapping,
																			allSubAreas: [],
																			shopsStructure,
																			shopCounts,
																			totalShopsFetched
																		});

																		await fetchShops({
																			functionToDataFetch,
																			computeData,
																			keyMapping,
																			source,
																			key,
																			originalKey,
																			selectedType,
																			dispatch,
																			keyNameMapping,
																			exclude,
																			tenant,
																			extraFilters
																		});
																	}}
																>
																	Download
																</Button>
															)}
													</td>

													<td className="elipsis">
														{
															<ProgressBar
																data={{
																	abbr: "",
																	percent: Math.round(
																		(shopsStructure.get(key)?.length /
																			shopCounts[key]) *
																			100 || 0
																	),
																	total: shopCounts[key] || 0,
																	loaded: shopsStructure.get(key)?.length || 0
																}}
															/>
														}
													</td>
													<td className="elipsis ">
														{<ProgressBar data={apiTracking[`${key}-Downloading`]} />}
													</td>
												</>
											)}
										</tr>
									);
								})}
							</table>
						</div>
					}
					title={title}
					trigger="hover"
					open={popOverOpsn && !disable}
					onOpenChange={value => {
						setPopOverOpen(value);
					}}
				>
					<Button disabled={disable}>{buttonLabel}</Button>
				</Popover>
			}
		</div>
	);
}

export default ShopDownloadStsts;

async function fetchShops({
	computeData,
	source,
	key,
	originalKey,
	selectedType,
	dispatch,
	exclude,
	keyNameMapping,
	functionToDataFetch,
	tenant,
	keyMapping,
	extraFilters
}) {
	try {
		dispatch({
			type: "setObject",
			actions: {
				set: {
					[`apiTracking.${key}-Downloading`]: { abbr: "Waiting For Server Response", percent: null }
				}
			}
		});
		const config = ["-Client", `-${variables.bat_contracted_outlets}`].includes(keyMapping)
			? clientDataConfig(tenant)
			: censusDataConfig(tenant);
		const {
			data: { shopMarkers, mapping }
		} = await functionToDataFetch({
			source,
			onDownloadProgress: progressEvent => {
				const { loaded, total } = progressEvent;
				const divisor = 1048576;
				const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
				dispatch({
					type: "setObject",
					actions: {
						set: {
							[`apiTracking.${key}-Downloading`]: { abbr: "Mbs", loaded, total, divisor, percent }
						}
					}
				});
			},
			params: { key: originalKey, selectedType, exclude, config, extraFilters }
		});

		computeData({ shopMarkers, mapping, keyNameMapping, dispatch, config, tenant });

		dispatch({
			type: "setObject",
			actions: {
				set: {
					[`apiTracking.${key}`]: "Completed"
				}
			}
		});

		dispatch({
			type: "UPDATETABLEDATA"
		});
	} catch (err) {
		console.error(err);
		const { message } = err;
		dispatch({
			type: "setObject",
			actions: {
				set: {
					[`apiTracking.${key}-Downloading`]: { abbr: message, percent: null },
					[`apiTracking.${key}`]: null
				}
			}
		});
	}
}

const getAllSubAreas = ({ _id, areasMapping, allSubAreas, shopsStructure, shopCounts, totalShopsFetched }) => {
	let data = areasMapping.get(_id);
	if (totalShopsFetched <= 0) return allSubAreas;
	if (data) {
		const sub_areas = data;
		if (sub_areas?.length > 0) {
			let exclude = [];
			let areasToBeChecked = [];
			sub_areas.forEach(_id => {
				if (totalShopsFetched > 0 && shopsStructure?.get(_id)?.length === shopCounts?.[_id]) {
					totalShopsFetched -= shopCounts[_id];
					exclude.push(_id);
				} else {
					areasToBeChecked.push(_id);
				}
			});
			allSubAreas = [...allSubAreas, ...exclude];
			for (let _id of areasToBeChecked) {
				allSubAreas = getAllSubAreas({
					_id,
					areasMapping,
					allSubAreas,
					shopsStructure,
					shopCounts,
					totalShopsFetched
				});
			}
		}
	}
	return allSubAreas;
};
function computeCensusShopsData({ shopMarkers, config, mapping, keyNameMapping, dispatch, tenant }) {
	let raw_markers = {};
	let shopsStructure = new Map();
	mapping = mapping.map(key => formateString(key.replace("_id", "")).toUpperCase());
	shopMarkers.forEach(shopData => {
		const dataWithMapping = {};
		config.forEach((key, index) => {
			dataWithMapping[key] = shopData[index];
		});
		const { marker, id } = mapMarkerData(dataWithMapping, false);
		const types = dataWithMapping[tenant];
		let areaInfo = {};
		mapping.forEach((key, index) => {
			if (types[index]) {
				if (!shopsStructure.has(types[index])) {
					shopsStructure.set(types[index], []);
				}
				shopsStructure.get(types[index]).push(id);
			}
			areaInfo[formateString(key)] = keyNameMapping[types[index]];
		});
		const tabelData = mapCensusTabelData(dataWithMapping, areaInfo, false, tenant);

		raw_markers[id] = { ...marker, data: tabelData };
	});

	dispatch({
		type: "setObject",
		actions: {
			merge: {
				raw_markers
			}
		}
	});

	dispatch({
		type: "MergeMaps",
		key: "shopsStructure",
		value: shopsStructure
	});
}

function computeClientShopsData({ shopMarkers, mapping, keyNameMapping, dispatch, config, tenant }) {
	let raw_tenant_markers = {};
	let shopsStructure = new Map();

	mapping = mapping.map(key => formateString(key.replace("_id", "")).toUpperCase());

	shopMarkers.forEach(shopData => {
		const dataWithMapping = {};
		config.forEach((key, index) => {
			dataWithMapping[key] = shopData[index];
		});
		const { marker, id } = mapMarkerData(dataWithMapping, true);
		const types = dataWithMapping["area"];
		let areaInfo = {};
		mapping.forEach((key, index) => {
			types[index]?.forEach(type => {
				let modifiedType = `${type}-Client`;
				if (modifiedType) {
					if (!shopsStructure.has(modifiedType)) {
						shopsStructure.set(modifiedType, []);
					}
					shopsStructure.get(modifiedType).push(id);
				}
				if (areaInfo[formateString(key)]) {
					areaInfo[formateString(key)] = `${areaInfo[key]}, ${keyNameMapping[type]}`;
				} else {
					areaInfo[formateString(key)] = keyNameMapping[type];
				}
			});
		});
		const tabelData = mapCensusTabelData(dataWithMapping, areaInfo, true, tenant);

		raw_tenant_markers[id] = { ...marker, data: tabelData };
	});

	// const sortMapping = new Map([
	// 	["AREA-DISTRIBUTOR-REGION-TERRITORY", ["REGION", "AREA", "TERRITORY", "DISTRIBUTOR"]]
	// ]);
	// let test = [...mapping].sort((a, b) => {
	// 	if (a < b) return -1;
	// 	else if (a > b) return 1;
	// 	else return 0;
	// });
	// const testMapping = sortMapping.get(test.join("-")) || mapping;

	dispatch({
		type: "setObject",
		actions: {
			merge: {
				raw_tenant_markers
			}
		}
	});
	dispatch({
		type: "MergeMaps",
		key: "shopsStructure",
		value: shopsStructure
	});
}

function compute3rdDataShopsData({ shopMarkers, mapping, keyNameMapping, dispatch, config, tenant }) {
	let raw_tenant_markers = {};
	let shopsStructure = new Map();

	mapping = mapping.map(key => formateString(key.replace("_id", "")).toUpperCase());

	shopMarkers.forEach(shopData => {
		const dataWithMapping = {};
		config.forEach((key, index) => {
			dataWithMapping[key] = shopData[index];
		});
		const { marker, id } = mapMarkerData(dataWithMapping, true);
		const types = dataWithMapping["area"];
		let areaInfo = {};
		mapping.forEach((key, index) => {
			types[index]?.forEach(type => {
				let modifiedType = `${type}-${variables.bat_contracted_outlets}`;
				if (modifiedType) {
					if (!shopsStructure.has(modifiedType)) {
						shopsStructure.set(modifiedType, []);
					}
					shopsStructure.get(modifiedType).push(id);
				}
				if (areaInfo[formateString(key)]) {
					areaInfo[formateString(key)] = `${areaInfo[key]}, ${keyNameMapping[type]}`;
				} else {
					areaInfo[formateString(key)] = keyNameMapping[type];
				}
			});
		});
		const tabelData = mapCensusTabelData(dataWithMapping, areaInfo, true, tenant);

		raw_tenant_markers[id] = { ...marker, data: tabelData };
	});

	// const sortMapping = new Map([
	// 	["AREA-DISTRIBUTOR-REGION-TERRITORY", ["REGION", "AREA", "TERRITORY", "DISTRIBUTOR"]]
	// ]);
	// let test = [...mapping].sort((a, b) => {
	// 	if (a < b) return -1;
	// 	else if (a > b) return 1;
	// 	else return 0;
	// });
	// const testMapping = sortMapping.get(test.join("-")) || mapping;

	dispatch({
		type: "setObject",
		actions: {
			merge: {
				raw_tenant_markers_1: raw_tenant_markers
			}
		}
	});
	dispatch({
		type: "MergeMaps",
		key: "shopsStructure",
		value: shopsStructure
	});
}
